function initTimelineSlider(slider) {
    console.log('test slider timeline')
    var $el = slider,
      pagination = $el.querySelector('.swiper-pagination'),
      loop = $el.querySelector('[data-loop]').getAttribute('data-loop') === 'true' ? true : false;
        
      $swiper = new Swiper($el, {
        centeredSlides: false,
        spaceBetween: 20,
        // slidesPerView: 'auto',
        // slidesOffsetBefore: 40,
        loop: loop,
        breakpoints: {
          767: {
            spaceBetween: 30,
            slidesPerView: 1,
            // slidesOffsetBefore: 10
          },
          1024: {
            spaceBetween: 120,
            slidesPerView: 'auto',
            slidesOffsetBefore: 40
          },
        },
         pagination: {
            el: pagination,
            clickable: false,
            dynamicBullets: false
        }
      });
    $el.style.visibility = 'visible';
    $el.style.opacity = 1;
    

  }
  
  setTimeout(() => {
    const $swiperContainer = document.querySelectorAll('.section-timeline-slider');
  
    if ($swiperContainer.length > 0) {
      $swiperContainer.forEach(function (element) {
        initTimelineSlider(element);
      });
    }
  }, 600);